import { createFileRoute } from "@tanstack/react-router";
import PageLayout from "@/components/layout/PageLayout";
import Login from "@/components/auth/Login";

export const Route = createFileRoute("/login")({
	component: () => (
		<PageLayout>
			<Login />
		</PageLayout>
	),
});
